module.exports = __webpack_public_path__ + "media/img/frontend_application/package-icon-6ae2f5f0d5c8f436adcfbe58088dfae9.svg";